module.exports = __webpack_public_path__ + "media/images/exclamation-triangle-c69e1f2edfec2a49a23ba82aa15b5d3a.svg";